import {combineReducers} from 'redux';
import {AppStorageState} from '../interfaces/appState.interface';
import {pollReducer} from './poll.reducer';
import {configReducer} from './config.reducer';
import {pollsReducer} from './polls.reducer';
import {questionsReducer} from './questions.reducer';
import {scriptQuestSetsReducer} from './scriptQuestSets.reducer';
import {scriptsReducer} from './scripts.reducer';
import {pollExtraFieldsReducer} from './pollExtraFields.reducer';
import {lastPollListLinkReducer} from './lastPollListLink.reducer';

const reducerMap = {
    config: configReducer,
    poll: pollReducer,
    pollExtraFields: pollExtraFieldsReducer,
    questions: questionsReducer,
    scriptQuestSets: scriptQuestSetsReducer,
    scripts: scriptsReducer,
    polls: pollsReducer,
    lastPollListLink: lastPollListLinkReducer
};

const appReducer = combineReducers<AppStorageState>(reducerMap);

export function rootReducer(state = {} as AppStorageState, action) {

    const nextState = appReducer(state, action);
    return nextState;

}
